import { IPluginMetadataSucceededResult } from 'app/apis/plugin-metadata-api.service';
import { format } from 'app/shared/utils/string.util';


const connector: IPluginMetadataSucceededResult = {
    connectorName: 'AppFigures',
    dataType: 'Hierarchical',
    SupportEncryption: true,
    connectionSettings: [
        {
            type: 'String',
            name: 'userName',
            required: true,
            sensitive: false,
            signature: true
          },
          {
            type: 'String',
            name: 'password',
            required: true,
            sensitive: true,
            signature: false
          },
          {
            type: 'String',
            name: 'clientKey',
            required: true,
            sensitive: true,
            signature: false
          }
    ],
    readSettings: [
        {
            type: 'String',
            name: 'entityType',
            displayName: stringResources.TableNameDisplay_EntityType,
            required: true
        }
    ],
    writeSettings: [],
    adfAppModelConfiguration: {
        displayName: format(stringResources.ModelName_DisplayTextPreviewTemplate, 'AppFigures'),
        icon: {
            className: 'svg-i-100x100-appfigures'
        },
        category: ['ServicesApps'],
        linkedService: {
            properties: [
                'userName',
                'password',
                'clientKey'
            ],
            uiControls: [
                {
                    bind: 'userName',
                    controlType: 'TextBox',
                    displayName: stringResources.ModelName_UserName
                },
                {
                    bind: 'password',
                    controlType: 'TextBox',
                    displayName: stringResources.ModelName_Password
                },
                {
                    bind: 'clientKey',
                    controlType: 'TextBox',
                    displayName: stringResources.ModelName_ClientKey
                }
            ]
        },
        dataflowInlineSource: {
            properties: [
                'entityType'
            ],
            uiControls: [
                {
                    bind: 'entityType',
                    controlType: 'DropDown',
                    displayName: stringResources.TableNameDisplay_EntityType,
                    required: true,
                    defaultValue: 'products',
                    controlSettings: {
                        options: [
                                { label: stringResources.Appfigure_EntityType_Products, value: 'products' },
                                { label: stringResources.Appfigure_EntityType_Ads, value: 'ads' },
                                { label: stringResources.Appfigure_EntityType_Sales, value: 'sales' }
                        ]
                    }
                }
            ],
            itemSettings: {
                dataflowType: 'appfigures',
                dataflowFormat: 'rest',
                dataflowUseInlineProjection: true
            }
        }
    }
};

export default connector;
